import { createSelector } from 'reselect';

export const selectVideoState = (state) => state.video;

export const selectVideoUrl = (videos) => videos && videos.videoUrl;

export const makeSelectVideoUrl = () => createSelector(
  selectVideoState,
  selectVideoUrl,
);

export const selectHasSnackbar = (videos) => videos && videos.hasSnackbar;

export const makeSelectHasSnackbar = () => createSelector(
  selectVideoState,
  selectHasSnackbar,
);

export const selectSnackbarMessage = (videos) => videos && videos.snackbarMessage;

export const makeSelectSnackbarMessage = () => createSelector(
  selectVideoState,
  selectSnackbarMessage,
);

export const selectSnackbarState = (videos) => videos && videos.snackbarState;

export const makeSelectSnackbarState = () => createSelector(
  selectVideoState,
  selectSnackbarState,
);

export const selectVideoId = (videos) => videos && videos.videoId;

export const makeSelectVideoId = () => createSelector(
  selectVideoState,
  selectVideoId,
);
